export const PROXIMITY_DRIVE_TIME_SET_PROXIMITY_PATHS = 'PROXIMITY_DRIVE_TIME_SET_PROXIMITY_PATH';
